import { Component } from 'react';
import { ArrowLeft, Home, RefreshCw, AlertOctagon } from 'lucide-react';

export default class AppErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('[AppErrorBoundary]', error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    handleGoHome = () => {
        window.location.href = '/';
    };

    handleGoBack = () => {
        window.history.back();
    };

    handleRetry = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }

        const isDev = import.meta.env?.DEV;

        return (
            <div className="min-h-screen bg-stone-50 flex items-center justify-center p-6">
                <div className="w-full max-w-lg text-center">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-red-50 mb-6">
                        <AlertOctagon size={32} className="text-red-400" />
                    </div>

                    <h1 className="text-2xl font-bold text-stone-900 mb-2">
                        Erreur inattendue
                    </h1>

                    <p className="text-stone-500 mb-8 max-w-sm mx-auto">
                        Un problème est survenu lors de l'affichage de cette page. Vous pouvez réessayer ou revenir à l'accueil.
                    </p>

                    {isDev && this.state.error && (
                        <div className="text-left text-xs text-red-700 bg-red-50 border border-red-200 rounded-xl px-4 py-3 mb-6 max-h-40 overflow-y-auto">
                            <p className="font-semibold mb-1">{this.state.error.toString()}</p>
                            {this.state.error.stack && (
                                <pre className="whitespace-pre-wrap text-red-500 mt-1">
                                    {this.state.error.stack.split('\n').slice(1, 6).join('\n')}
                                </pre>
                            )}
                        </div>
                    )}

                    <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                        <button
                            type="button"
                            onClick={this.handleGoBack}
                            className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-stone-700 bg-white border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors"
                        >
                            <ArrowLeft size={15} />
                            Retour
                        </button>
                        <button
                            type="button"
                            onClick={this.handleRetry}
                            className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-stone-700 bg-white border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors"
                        >
                            <RefreshCw size={15} />
                            Réessayer
                        </button>
                        <button
                            type="button"
                            onClick={this.handleGoHome}
                            className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-white bg-stone-900 rounded-xl hover:bg-stone-800 transition-colors"
                        >
                            <Home size={15} />
                            Accueil
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
